import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreateSickLeaveMutation as useDeCreateSickLeaveMutationType } from "@/modules/patients/detail/sick-leave-certificate/de/services/__generated__/useDeCreateSickLeaveMutation.graphql"

const createSickLeaveMutation = graphql`
  mutation useDeCreateSickLeaveMutation($input: De_createSickLeaveInput!) {
    de_createSickLeave(input: $input) {
      de_SickLeave {
        id
        ...deSickLeaveFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreateSickLeaveMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreateSickLeaveMutationType>(
    createSickLeaveMutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateSickLeaveMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateSickLeaveMutation }
